import toast, {
  Renderable,
  Toast,
  ToastOptions,
  ValueOrFunction,
} from 'react-hot-toast';

type Message = ValueOrFunction<Renderable, Toast>;
type ToastHandler = (message: Message, options?: ToastOptions) => string;

interface IUseQueryToast {
  failure: ToastHandler;
  success: ToastHandler;
  loading: ToastHandler;
  custom: ToastHandler;
  dismiss: () => void;
  remove: () => void;
}

export const useQueryToast = (toastId: string): IUseQueryToast => {
  const failure = (message: Message, options?: ToastOptions) =>
    toast.error(message, { id: toastId, ...options });
  const success = (message: Message, options?: ToastOptions) =>
    toast.success(message, { id: toastId, ...options });
  const loading = (message: Message, options?: ToastOptions) =>
    toast.loading(message, { id: toastId, ...options });
  const custom = (message: Message, options?: ToastOptions) =>
    toast.custom(message, { id: toastId, ...options });
  const dismiss = () => toast.dismiss(toastId);
  const remove = () => toast.remove(toastId);

  return { failure, success, loading, custom, dismiss, remove };
};
